export const appBaseURL = "/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"http-equiv":"origin-trial","content":"Al3rVzEqbDO51+MKnTbfHx2jV7azPv/+srFo1rwOzs2JEkoLf+pwCxxIc0tqeaXHYKBMjuBt7hjKo5CyBmH1Vg8AAABeeyJvcmlnaW4iOiJodHRwczovLzBkZXRlY3QuY29tOjQ0MyIsImZlYXR1cmUiOiJXZWJNQ1AiLCJleHBpcnkiOjE3OTQ4NzM2MDAsImlzU3ViZG9tYWluIjp0cnVlfQ=="},{"property":"og:image","content":"https://0detect.com/meta/0detect-meta-en.webp"},{"property":"twitter:image","content":"https://0detect.com/meta/0detect-meta-en.webp"},{"property":"og:site_name","content":"0detect.com"},{"property":"og:url","content":"https://0detect.com/"}],"link":[{"rel":"preconnect","href":"https://mc.yandex.ru"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"}],"style":[],"script":[{"id":"schema-org","type":"application/ld+json","innerHTML":"[{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"name\":\"0DETECT\",\"url\":\"https://0detect.com\",\"logo\":\"https://0detect.com/meta/0detect-meta-en.webp\",\"description\":\"Professional anti-detect browser for managing multiple browser profiles with unique fingerprints.\",\"sameAs\":[\"https://docs.0detect.com\"]},{\"@context\":\"https://schema.org\",\"@type\":\"WebSite\",\"name\":\"0DETECT\",\"url\":\"https://0detect.com\",\"potentialAction\":{\"@type\":\"SearchAction\",\"target\":{\"@type\":\"EntryPoint\",\"urlTemplate\":\"https://0detect.com/blog?q={search_term_string}\"},\"query-input\":\"required name=search_term_string\"}},{\"@context\":\"https://schema.org\",\"@type\":\"SoftwareApplication\",\"name\":\"0DETECT Anti-Detect Browser\",\"url\":\"https://0detect.com\",\"applicationCategory\":\"BrowserApplication\",\"operatingSystem\":\"Windows, macOS\",\"description\":\"Anti-detect browser for managing multiple isolated browser profiles with unique fingerprints, proxy support, cookie management, and team collaboration.\",\"offers\":{\"@type\":\"Offer\",\"price\":\"0\",\"priceCurrency\":\"USD\",\"description\":\"Free trial available\"},\"publisher\":{\"@type\":\"Organization\",\"name\":\"Green Advex Technology LLC\",\"url\":\"https://0detect.com\"}}]"},{"id":"yandex-metrika","innerHTML":"(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();for(var j=0;j<document.scripts.length;j++){if(document.scripts[j].src===r){return;}}k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window,document,'script','https://mc.yandex.ru/metrika/tag.js?id=109025584','ym');ym(109025584,'init',{ssr:true,webvisor:true,clickmap:true,ecommerce:'dataLayer',referrer:document.referrer,url:location.href,accurateTrackBounce:true,trackLinks:true});","type":"text/javascript","body":true}],"noscript":[{"children":"<div><img src=\"https://mc.yandex.ru/watch/109025584\" style=\"position:absolute; left:-9999px;\" alt=\"\" /></div>"},{"children":"<img height=\"1\" width=\"1\" style=\"display:none\" src=\"https://www.facebook.com/tr?id=1328702838301394&ev=PageView&noscript=1\"/>"},{"children":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-WC38WHFF\"\n            height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}],"__dangerouslyDisableSanitizersByTagID":{"schema-org":["innerHTML"],"yandex-metrika":["innerHTML"]}}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000